/**
 * Generated from ch4_p10.fla
 */
export function ch4_p10(this: Ich4_p10) {
	const holly = this.holly;
	if (!holly[0] && holly.elementFactory) {
		holly[0] = holly.elementFactory(0,undefined);
	}
	if (holly[0]) {
		ch4_p10_hh_ch4_p010psdAssetchp4_p10_hollyguitar.call(holly[0] as Ich4_p10_hh_ch4_p010psdAssetchp4_p10_hollyguitar);
		holly[0].x = 749.25;
		holly[0].y = 458;
		holly[0].width = 460.50;
		holly[0].height = 488.00;
		holly[0].alpha = 1;
		if (holly[0].onLayout) holly[0].onLayout();
	}
	if (!holly[1] && holly.elementFactory) {
		holly[1] = holly.elementFactory(1,undefined);
	}
	if (holly[1]) {
		ch4_p10_hh_ch4_p011psdAssetchp4_p11_holly.call(holly[1] as Ich4_p10_hh_ch4_p011psdAssetchp4_p11_holly);
		holly[1].x = 1135;
		holly[1].y = 768;
		holly[1].width = 316.00;
		holly[1].height = 651.00;
		holly[1].alpha = 1;
		if (holly[1].onLayout) holly[1].onLayout();
	}
	const bg = this.bg;
	ch4_p10_hh_ch4_p010psdAsset1chp4_p10_bg.call(this.bg);
	bg.x = 832;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	bg.alpha = 1.00;
	if (bg.onLayout) bg.onLayout();
	const doorClosed = this.doorClosed;
	ch4_p10_hh_ch4_p010psdAsset1chp4_p10_doorclosed.call(this.doorClosed);
	doorClosed.x = 1231.75;
	doorClosed.y = 384;
	doorClosed.width = 147.50;
	doorClosed.height = 768.00;
	doorClosed.alpha = 1.00;
	if (doorClosed.onLayout) doorClosed.onLayout();
	const doorOpen = this.doorOpen;
	ch4_p10_hh_ch4_p010psdAsset1chp4_p11_dooropen.call(this.doorOpen);
	doorOpen.x = 1232.25;
	doorOpen.y = 384;
	doorOpen.width = 152.50;
	doorOpen.height = 768.00;
	doorOpen.alpha = 1.00;
	if (doorOpen.onLayout) doorOpen.onLayout();
	const guitar = this.guitar;
	ch4_p10_hh_ch4_p010psdAssetchp4_p10_guitar.call(this.guitar);
	guitar.x = 597;
	guitar.y = 471;
	guitar.width = 159.00;
	guitar.height = 351.00;
	guitar.alpha = 1.00;
	if (guitar.onLayout) guitar.onLayout();
	const basket = this.basket;
	ch4_p10_hh_ch4_p010psdAssetchp4_p10_basket.call(this.basket);
	basket.x = 1030.5;
	basket.y = 656.75;
	basket.width = 259.00;
	basket.height = 222.50;
	basket.alpha = 1.00;
	if (basket.onLayout) basket.onLayout();
	const sigh = this.sigh;
	ch4_p10_hh_ch4_p010psdAssetchp4_p10_sigh.call(this.sigh);
	sigh.x = 841.25;
	sigh.y = 217.5;
	sigh.width = 31.50;
	sigh.height = 33.00;
	sigh.alpha = 1.00;
	if (sigh.onLayout) sigh.onLayout();
	const frameRight = this.frameRight;
	ch4_p10_hh_ch4_p010psdAssetchp4_p10_wcframeR.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384;
	frameRight.width = 356.00;
	frameRight.height = 768.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const frameLeft = this.frameLeft;
	ch4_p10_hh_ch4_p010psdAssetchp4_p10_wcframeL.call(this.frameLeft);
	frameLeft.x = 0;
	frameLeft.y = 384;
	frameLeft.width = 344.00;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	const linesLeft = this.linesLeft;
	ch4_p10_hh_ch4_p010psdAssetchp4_p10_wcframeLlines.call(this.linesLeft);
	linesLeft.x = 0;
	linesLeft.y = 368.25;
	linesLeft.width = 77.50;
	linesLeft.height = 626.50;
	linesLeft.alpha = 1.00;
	if (linesLeft.onLayout) linesLeft.onLayout();
	return this;
}
function ch4_p10_hh_ch4_p010psdAsset1chp4_p10_bg(this: Ich4_p10_hh_ch4_p010psdAsset1chp4_p10_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp4_p10_bg", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p10_hh_ch4_p010psdAsset1chp4_p10_doorclosed(this: Ich4_p10_hh_ch4_p010psdAsset1chp4_p10_doorclosed) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp4_p10_doorclosed", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p10_hh_ch4_p010psdAsset1chp4_p11_dooropen(this: Ich4_p10_hh_ch4_p010psdAsset1chp4_p11_dooropen) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp4_p11_dooropen", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p10_hh_ch4_p010psdAssetchp4_p10_guitar(this: Ich4_p10_hh_ch4_p010psdAssetchp4_p10_guitar) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp4_p10_guitar", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p10_hh_ch4_p010psdAssetchp4_p10_basket(this: Ich4_p10_hh_ch4_p010psdAssetchp4_p10_basket) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp4_p10_basket", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p10_hh_ch4_p010psdAssetchp4_p10_hollyguitar(this: Ich4_p10_hh_ch4_p010psdAssetchp4_p10_hollyguitar) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp4_p10_hollyguitar", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p10_hh_ch4_p010psdAssetchp4_p10_sigh(this: Ich4_p10_hh_ch4_p010psdAssetchp4_p10_sigh) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp4_p10_sigh", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p10_hh_ch4_p011psdAssetchp4_p11_holly(this: Ich4_p10_hh_ch4_p011psdAssetchp4_p11_holly) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp4_p11_holly", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p10_hh_ch4_p010psdAssetchp4_p10_wcframeR(this: Ich4_p10_hh_ch4_p010psdAssetchp4_p10_wcframeR) {
	if (this.setLayoutTexture) this.setLayoutTexture("R", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch4_p10_hh_ch4_p010psdAssetchp4_p10_wcframeL(this: Ich4_p10_hh_ch4_p010psdAssetchp4_p10_wcframeL) {
	if (this.setLayoutTexture) this.setLayoutTexture("L", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch4_p10_hh_ch4_p010psdAssetchp4_p10_wcframeLlines(this: Ich4_p10_hh_ch4_p010psdAssetchp4_p10_wcframeLlines) {
	if (this.setLayoutTexture) this.setLayoutTexture("Llines", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
interface Ich4_p10Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich4_p10Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich4_p10Sprite extends Ich4_p10Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich4_p10Text extends Ich4_p10Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich4_p10Polygon extends Array<number> {
}
interface Ich4_p10 {
	readonly holly: Ich4_p10Array<Ich4_p10_hh_ch4_p010psdAssetchp4_p10_hollyguitar|Ich4_p10_hh_ch4_p011psdAssetchp4_p11_holly>;
	readonly bg: Ich4_p10_hh_ch4_p010psdAsset1chp4_p10_bg;
	readonly doorClosed: Ich4_p10_hh_ch4_p010psdAsset1chp4_p10_doorclosed;
	readonly doorOpen: Ich4_p10_hh_ch4_p010psdAsset1chp4_p11_dooropen;
	readonly guitar: Ich4_p10_hh_ch4_p010psdAssetchp4_p10_guitar;
	readonly basket: Ich4_p10_hh_ch4_p010psdAssetchp4_p10_basket;
	readonly sigh: Ich4_p10_hh_ch4_p010psdAssetchp4_p10_sigh;
	readonly frameRight: Ich4_p10_hh_ch4_p010psdAssetchp4_p10_wcframeR;
	readonly frameLeft: Ich4_p10_hh_ch4_p010psdAssetchp4_p10_wcframeL;
	readonly linesLeft: Ich4_p10_hh_ch4_p010psdAssetchp4_p10_wcframeLlines;
}
interface Ich4_p10_hh_ch4_p010psdAsset1chp4_p10_bg extends Ich4_p10Sprite {
}
interface Ich4_p10_hh_ch4_p010psdAsset1chp4_p10_doorclosed extends Ich4_p10Sprite {
}
interface Ich4_p10_hh_ch4_p010psdAsset1chp4_p11_dooropen extends Ich4_p10Sprite {
}
interface Ich4_p10_hh_ch4_p010psdAssetchp4_p10_guitar extends Ich4_p10Sprite {
}
interface Ich4_p10_hh_ch4_p010psdAssetchp4_p10_basket extends Ich4_p10Sprite {
}
interface Ich4_p10_hh_ch4_p010psdAssetchp4_p10_hollyguitar extends Ich4_p10Sprite {
}
interface Ich4_p10_hh_ch4_p010psdAssetchp4_p10_sigh extends Ich4_p10Sprite {
}
interface Ich4_p10_hh_ch4_p011psdAssetchp4_p11_holly extends Ich4_p10Sprite {
}
interface Ich4_p10_hh_ch4_p010psdAssetchp4_p10_wcframeR extends Ich4_p10Sprite {
}
interface Ich4_p10_hh_ch4_p010psdAssetchp4_p10_wcframeL extends Ich4_p10Sprite {
}
interface Ich4_p10_hh_ch4_p010psdAssetchp4_p10_wcframeLlines extends Ich4_p10Sprite {
}
